export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': 'dd1c63c74emshac0209891fcc0f5p1db0e9jsn898ed874358a',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";   

export const WEATHER_API_KEY = "e03a5bf66c3b25f8efbf1f1a6c9a33c8";